/* global van11yAccessibleTabPanelAria */
import {register} from '@shopify/theme-sections';

const selectors = {
  tabs: '[data-tabs]',
};

const sectionType = 'featured-collections-tabs';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;

      // Only run in the admin theme customizer
      if (Shopify.designMode) {
        // Reinitialise tabs after adding/removing blocks
        const tabs = container.querySelector(selectors.tabs);

        // Only reinitialise if the tabs exist and tabs JS hasn't already run (it gives the tabs div an id)
        if (tabs && !tabs.id) {
          van11yAccessibleTabPanelAria(container);
        }
      }
    },
  });
